import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { compose, mapProps } from 'recompose';
import PropTypes from 'prop-types';
import { listTemplateFieldsForCategory } from 'graphql/operations';
import { NETWORK_ONLY } from 'graphql/fetchPolicies';
import TemplateQuestion from 'components/threepp/assessment/Question/TemplateQuestion';

export class TemplateQuestionsManager extends Component {
  static propTypes = {
    visible: PropTypes.bool,
    hasMore: PropTypes.bool,
    hasFields: PropTypes.bool,
    lastCursor: PropTypes.number,
    loading: PropTypes.bool.isRequired,
    // TODO: Fix this...
    /* eslint-disable react/forbid-prop-types */
    questions: PropTypes.array.isRequired,
    template: PropTypes.object.isRequired,
    onQueryComplete: PropTypes.func.isRequired,
    queryVariables: PropTypes.object.isRequired,
    /* eslint-enable react/forbid-prop-types */
    incrementAttachmentUploadCount: PropTypes.func.isRequired,
    decrementAttachmentUploadCount: PropTypes.func.isRequired
  };

  static defaultProps = {
    visible: false,
    hasMore: false,
    hasFields: false,
    lastCursor: null
  };

  componentDidUpdate(prevProps) {
    const { loading, onQueryComplete } = this.props;
    if (loading !== prevProps.loading) {
      if (!loading) {
        const { lastCursor, hasMore, hasFields, queryVariables } = this.props;
        onQueryComplete(lastCursor, hasMore, hasFields, queryVariables);
      }
    }
  }

  render() {
    const { visible, questions, template, incrementAttachmentUploadCount, decrementAttachmentUploadCount } = this.props;

    if (!visible) {
      return null;
    }
    const questionSubset = questions.map(question => (
      <TemplateQuestion
        key={question.id}
        question={question}
        template={template}
        incrementAttachmentUploadCount={incrementAttachmentUploadCount}
        decrementAttachmentUploadCount={decrementAttachmentUploadCount}
      />
    ));
    return questionSubset;
  }
}

export const TemplateQuestionLoaderHOC = compose(
  withRouter,
  graphql(listTemplateFieldsForCategory, {
    options: props => {
      return {
        variables: props.variables,
        fetchPolicy: NETWORK_ONLY
      };
    }
  }),
  mapProps(props => {
    const { template, data, visible, onQueryComplete, variables } = props;
    let questions = [];
    let hasMore = false;
    let hasFields = false;
    let lastCursor = null;

    if (data.listTemplateFieldsForCategory) {
      const { edges, pageInfo } = props.data.listTemplateFieldsForCategory;
      questions = edges.map(edge => edge.node);
      hasMore = pageInfo.hasNextPage;
      hasFields = questions.length > 0;
      lastCursor = pageInfo.hasNextPage ? edges[edges.length - 1].cursor : null;
    }

    return {
      loading: props.data.loading,
      queryVariables: variables,
      visible,
      questions,
      hasMore,
      hasFields,
      lastCursor,
      onQueryComplete,
      template,
      incrementAttachmentUploadCount: props.incrementAttachmentUploadCount,
      decrementAttachmentUploadCount: props.decrementAttachmentUploadCount
    };
  })
);

export default TemplateQuestionLoaderHOC(TemplateQuestionsManager);
